import { Modal } from "react-bootstrap";

export default class Mensajes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: this.props.showModal,
    };
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleHide() {
    this.setState({ showModal: false });
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  componentWillReceiveProps(props) {
    this.setState({ showModal: props.showModal });
  }

  render() {
    return (
      <div id="modal-wrap-alert-modal">
        <div className="modal-container">
          <Modal
            show={this.state.showModal}
            container={this.props.container}
            onHide={this.handleHide}
            bsSize="large"
            backdrop="static"
            aria-labelledby="contained-modal-title-lg"
          >
            <Modal.Header>
              <Modal.Title>{this.props.MessageTitle}</Modal.Title>
              <Button
                className={this.props.NoX + ""}
                onClick={() => {
                  this.handleHide();
                  this.props.closeModal();
                }}
              >
                <i className="fa fa-times"></i>
              </Button>
            </Modal.Header>
            <Modal.Body>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 modal-error-body">
                <div className="col-xs-12 col-sm-3 col-md-2 col-lg-2 left-error-modal">
                  <i
                    className={this.props.Icono + " " + this.props.colorIco}
                  ></i>
                </div>
                <div className="col-xs-12 col-sm-9 col-md-10 col-lg-10 right-error-modal">
                  {this.props.msg}
                </div>
              </div>
              <div className="inner-Model-buttons">
                {this.props.DescargarButtonText &&
                this.props.DescargarButtonAction &&
                this.props.showDescargaOption ? (
                  <Button
                    className={
                      this.props.NoAceptar + " btn__descargar--consentimiento"
                    }
                    onClick={() => {
                      this.handleHide();
                      this.props.DescargarButtonAction();
                    }}
                  >
                    <div className="descargabtn--container">
                      <div className="descarga--btn">
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth={0}
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                            stroke="none"
                          />
                        </svg>
                      </div>

                      <p>{this.props.DescargarButtonText}</p>
                    </div>
                  </Button>
                ) : null}
                {this.props.MainButtonText ? (
                  <Button
                    className={
                      this.props.NoAceptar + " btn btn-primary btn-si btn-left"
                    }
                    onClick={() => {
                      this.handleHide();
                      this.props.MainButtonAction();
                    }}
                  >
                    {this.props.MainButtonText}
                  </Button>
                ) : null}
                {this.props.AltButtonText ? (
                  <Button
                    className={
                      this.props.NoCancelar +
                      " btn btn-default btn-no btn-right"
                    }
                    onClick={() => {
                      this.handleHide();
                      this.props.AltButtonAction();
                    }}
                  >
                    {this.props.AltButtonText}
                  </Button>
                ) : null}
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

// const Modal = ReactBootstrap.Modal;
const Button = ReactBootstrap.Button;
